var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section message"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"message-text"},[_vm._v(" "+_vm._s(_vm.$route.params.message)+" ")]),_c('div',{staticClass:"btn-container"},[_c('Button',{staticClass:"btn btn-success button",attrs:{"type":"button"},on:{"click":_vm.onClickButton}},[_vm._v(" На главную ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }